/** Design System — Spacing scale (px). No arbitrary spacing allowed. */
export const spacing = {
  none: 0,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
  xxxl: 40,
  x4l: 48,
  x5l: 64,
} as const;

export type Spacing = typeof spacing;
